import { styled } from 'styled-components'

import Chip from 'core/components/lib/Chip'

const AgentOnlyBadge = styled(Chip).attrs({ $size: 'sm', $variant: 'dark' })`
  flex: none;
  letter-spacing: 0.5px;
`

export default AgentOnlyBadge
